export const getPageContext = () => {
  const mountNode = document.getElementById('film-network-cinemas');

  if (!mountNode) {
    return null;
  }

  const dataNode = document.getElementById('film-network-cinemas-data');
  let payload = {};

  if (dataNode && dataNode.textContent.trim()) {
    try {
      payload = JSON.parse(dataNode.textContent);
    } catch (error) {
      console.error('film-network-cinemas: invalid JSON', error);
    }
  }

  const cinemas = Array.isArray(payload)
    ? payload
    : Array.isArray(payload.cinemas)
      ? payload.cinemas
      : [];

  return {
    filmId: mountNode.dataset.filmId,
    filmUrl: mountNode.dataset.filmUrl || window.location.pathname,
    city: mountNode.dataset.city || '',
    currentCinemaId: mountNode.dataset.currentCinemaId || '',
    todayKey: payload.today || '',
    tomorrowKey: payload.tomorrow || '',
    cinemas,
  };
};

export const isCurrentCinema = (cinema, currentCinemaId) => {
  if (currentCinemaId && cinema.id) {
    return String(cinema.id) === String(currentCinemaId);
  }

  if (!cinema.link) {
    return false;
  }

  try {
    const cinemaHost = new URL(cinema.link).hostname;
    return window.location.hostname === cinemaHost;
  } catch (error) {
    return false;
  }
};

export const filterCityCinemas = (cinemas, city, currentCinemaId) =>
  cinemas.filter(cinema => {
    if (city && cinema.city && cinema.city !== city) {
      return false;
    }

    return !isCurrentCinema(cinema, currentCinemaId);
  });

export const countSessionsForDate = (sessions, dateKey) => {
  if (!sessions || !dateKey || !sessions[dateKey]) {
    return 0;
  }

  return sessions[dateKey].filter(session => !session.del).length;
};

export const countTodaySessions = (sessions, todayKey) =>
  countSessionsForDate(sessions, todayKey);

export const getSessionsMeta = (cinema, todayKey, tomorrowKey) => {
  const todayCount = countSessionsForDate(cinema.sessions, todayKey);
  const tomorrowCount = countSessionsForDate(cinema.sessions, tomorrowKey);

  if (todayCount > 0) {
    return { label: 'Сегодня', count: todayCount };
  }

  if (tomorrowCount > 0) {
    return { label: 'Завтра', count: tomorrowCount };
  }

  if (cinema.sessions_count > 0) {
    const label = cinema.sessions_day === 'tomorrow' ? 'Завтра' : 'Сегодня';

    return { label, count: cinema.sessions_count };
  }

  return null;
};

export const getSessionPriceLabel = session => {
  if (
    session.price_min !== undefined &&
    session.price_max !== undefined &&
    session.price_min !== session.price_max
  ) {
    return `от ${session.price_min} ₽`;
  }

  return `${session.price} ₽`;
};

export const getCinemaFilmUrl = (cinema, filmUrl) => {
  const baseUrl = (cinema.link || '').replace(/\/$/, '');
  const filmPath = filmUrl.startsWith('/') ? filmUrl : `/${filmUrl}`;

  return `${baseUrl}${filmPath}`;
};

export const formatDayLabel = (date, todayKey, tomorrowKey) => {
  if (date === todayKey) {
    return `Сегодня ${date.slice(0, 5)}`;
  }

  if (date === tomorrowKey) {
    return `Завтра ${date.slice(0, 5)}`;
  }

  return date;
};

export const pluralizeSessions = count => {
  const mod10 = count % 10;
  const mod100 = count % 100;

  if (mod10 === 1 && mod100 !== 11) {
    return `${count} сеанс`;
  }

  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
    return `${count} сеанса`;
  }

  return `${count} сеансов`;
};
